/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';

export async function fetchAssetById(assetId: string) {
    return axios.get('/api/search', {
        params: {
            fq: `asset_id:${assetId}`,
        },
    });
}

export async function fetchAssetByParkPassFacilityId(id: string) {
    return axios.get('/api/search', {
        params: {
            fq: `park_pass_facility_id_s:${id}`,
        },
    });
}
